module.exports = __webpack_public_path__ + "img/Innovation-2021.547b3774.png";